// eslint-disable max-len
export default {
  paymentMethodCard: 'Tarjeta de crédito',
  paymentMethodPaypal: 'Paypal',
  paymentMethodBankTransfer: 'Transferencia bancaria',
  paymentMethodOXXO: 'OXXO',
  paymentMethodAffirm: 'Affirm',
  paymentMethodApplePay: 'Apple Pay',
  paymentMethodGooglePay: 'Google Pay',
  firstName: 'Nombre',
  lastName: 'Apellido',
  fullName: 'Nombre y apellido',
  email: 'Correo electrónico',
  cardholderName: 'Titular de la tarjeta',
  selectPaymentMethod: 'Seleccione su método de pago preferido',
  contactInformation: 'Información de contacto',
  paymentDetails: 'Detalles del pago',
  cardNumber: 'Número de la tarjeta',
  cardExpire: 'Fecha de caducidad',
  sameAsAddress: 'Igual que la dirección',
  billingAddressDetails: 'Dirección de facturación',
  billingStreetAddress: 'Dirección',
  billingStreetAddress2: 'Apartamento, suite, piso, etc.',
  billingCountry: 'País',
  billingState: 'Estado o región',
  billingCity: 'Ciudad',
  billingZip: 'Código postal',
  billingEmail: 'Correo electrónico',
  invalidEmail: 'Correo electrónico no válido',
  requiredField: 'Campo obligatorio',
  oxxoMessage:
    'Se le proporcionarán instrucciones de pago después de confirmar la reserva.',
  affirmMessage: 'Se le proporcionarán instrucciones para completar el pago.',
  applePayNotAvailableMessage:
    'Apple Pay no está disponible actualmente. Nos disculpamos por cualquier inconveniente. Por favor, elija otro método de pago.',
  googlePayNotAvailableMessage:
    'Google Pay no está disponible actualmente. Nos disculpamos por cualquier inconveniente. Por favor, elija otro método de pago.',
  paymentMethodError:
    'Lo sentimos, no pudimos procesar su pago. Por favor, elija otro método de pago.',
  bankTransferMessage:
    'Se le proporcionarán las instrucciones de transferencia después de confirmar la reserva.',
  unsupportedCardType: 'Tipo de tarjeta no compatible.',
  creditCardTypesAccepted: 'Tipos de tarjeta de crédito aceptados',
  payPalPaymentCurrency: 'El pago se procesará en {{currency}}.',
};
